import React from 'react'

import { CLICK_CODE } from '@local/utils'

import FlickingArea from '@web/components/FlickingArea/FlickingArea'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'
import FlickingContentMoreButton from '@web/ui/components/FlickingContentMoreButton'

import { Section, SectionHeader, SectionContent } from '../Section'
import MissionCardItem from './components/MissionCardItem'
import styles from './MissionSection.module.scss'

interface Props {
  title: string
  description?: string
  cards: React.ComponentProps<typeof MissionCardItem>[]
  isParticipating: boolean
  onClickMore: () => void
  displayMoreButton?: boolean
}

export default function UIMissionSection({ title, description, cards, onClickMore, isParticipating }: Props) {
  return (
    <Section className={styles.mission_section}>
      <SectionHeader
        title={title}
        description={description}
        clickHandler={() => {
          sendClickLog({ area: CLICK_CODE[isParticipating ? 'mymission.title' : 'mymission.emptytitle'] })
          onClickMore()
        }}
      />
      <SectionContent>
        <FlickingArea
          className={styles.flicking_area}
          options={{ cameraTag: 'ul' }}
          arrowOption={{ hasGradient: true }}
        >
          {cards.map(card => {
            const { key, ...cardProps } = card
            return <MissionCardItem key={key} {...cardProps} />
          })}
          <li className={styles.list_item}>
            <FlickingContentMoreButton
              hideButtonName
              onClick={onClickMore}
              clickCode={isParticipating ? CLICK_CODE['mymission.more'] : CLICK_CODE['mymission.emptymore']}
            />
          </li>
        </FlickingArea>
      </SectionContent>
    </Section>
  )
}
